module.exports = __webpack_public_path__ + "static/media/loans.23b1145c.svg";